module.exports = {
  key: "dashboard",
  dashboard: {
  },
  attribute: {},
  placeholder: {},
};
